import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as $ from 'jquery';
declare var Forensic: any;
declare global {
    interface Window {
        pass_params: () => string;
        to_object: (input: string) => any;
    }
}
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


    operatingSystem: string;
    captchaResponse: string = '';
    public apiInputs = { "project_id": "", "supplier_id": "", "token": "", "ip_address": "", "uid": "", "browser_name": "", "device_type": "", "utm_source": "", "utm_medium": "", "utm_term": "", "campaign_id": "", "operating_system": "", "userprojectid": "", "email": "", "otp": "", "useruniqueprojectid": "", "response": "", "useragent": "", "projectcode": "", "resid": "", "projectcountry": "", "tid": "", "pid": "", "paramsdata": "", "jsondata": "", "router": "", "question_arr": "", "paramspass": "", "url_type": "", "session_id": "", "projectCode": "", "respondentId": "" };
    public projectid: any = '';
    public supplierid: any = '';
    public token: any = '';
    public clientlogo = '';
    public logoimage = '';
    public ipAddress = "";
    public message = "Welcome";
    public urldata = "";
    public isquestion = "";
    public is_boat = 0;
    public is_email = 0;
    public uid = "";
    public customer = "";
    public browserName = '';
    public browserVersion = '';
    public embeded_url: any = "";
    public utm_source = '';
    public utm_medium = '';
    public utm_term = '';
    public campaign_id = '';
    public status: any = "";
    public url: any = "";
    public currentProjectid: any = '';
    public uniqueProjectid: any = '';
    public emaildata = { "email": "" }
    public otpdata = { "otp": "" }
    public email: any = "";
    public otp: any = [];
    public otp_send = 0;
    update_sec = 60;
    resend = false;
    resendotp = true;
    public captcha = 0;
    public textanalyzer = 0;
    public is_email_message = 'Please enter your email address';
    public otp_message = '';
    public premsg = 0;
    public projectcode = '';
    public resid = '';
    public projectconntry = '';
    public userprojectid = '';
    public is_captcha = 0;
    public useragent = '';
    public tid: any = '';
    public pid: any = '';
    public paramsData: any = '';
    public supcode = '';
    get_question_arr: any = {}
    device_type_resp: any = '';
    public paramspass = '';
    public url_type = 0;
    constructor(
        public apiService: ApiService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService,
        public http: HttpClient,
        public sanitized: DomSanitizer,




    ) {

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            if (typeof params.projectid != 'undefined' && params.projectid != '' && params.projectid != null &&
                typeof params.supplierid != 'undefined' && params.supplierid != '' && params.supplierid != null
            ) {
                this.paramsData = params;

                this.get_question_arr = this.paramsData;
                this.get_question_arr = { ...this.get_question_arr };
                delete this.get_question_arr['projectid'];
                delete this.get_question_arr['supplierid'];
                delete this.get_question_arr['url'];
                delete this.get_question_arr['token'];
                delete this.get_question_arr['uid'];

                this.projectid = params.projectid;
                this.supplierid = params.supplierid;
                this.token = params?.token;
                this.uid = params?.uid;
                this.tid = params?.tid;
                this.pid = params?.pid;
                this.apiInputs.paramsdata = this.paramsData;
                this.apiInputs.project_id = this.projectid;
                this.apiInputs.supplier_id = this.supplierid;
                this.apiInputs.token = this.token;
                this.apiInputs.uid = this.uid;
                this.apiInputs.tid = this.tid;
                this.apiInputs.pid = this.pid;

                if (typeof params.utm_source != 'undefined' && params.utm_source != '' && params.utm_source != null) {
                    this.apiInputs.utm_source = params.utm_source;
                }
                if (typeof params.utm_medium != 'undefined' && params.utm_medium != '' && params.utm_medium != null) {
                    this.apiInputs.utm_medium = params.utm_medium;
                }
                if (typeof params.utm_term != 'undefined' && params.utm_term != '' && params.utm_term != null) {
                    this.apiInputs.utm_term = params.utm_term;
                }
                if (typeof params.campaign_id != 'undefined' && params.campaign_id != '' && params.campaign_id != null) {
                    this.apiInputs.campaign_id = params.campaign_id;
                }
                if (typeof params.router != 'undefined' && params.router != '' && params.router != null) {
                    this.apiInputs.router = params.router;
                }
                if (this.get_question_arr) {
                    this.apiInputs.question_arr = this.get_question_arr;
                }

            }
            else {
                this.router.navigate(['not-found']);
            }
        });

        this.operatingSystem = window.navigator.platform;


    }
    siteKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";
    secretKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";


    ngOnInit(): void {

        this.localStorageService.removeItem("currentCustomer");
        this.get_feedback_list();
        this.browserVersion = this.detectBrowserVersion();
        setInterval(() => {
            if (this.update_sec > 0) {
                this.update_sec = this.update_sec - 1;
            } else {
                this.resend = true;
                this.resendotp = false;
            }
        }, 1000);


    }

    handleCaptchaResponse(response: string): void {
        this.captchaResponse = response;

    }

    async get_feedback_list(): Promise<any> {
        this.currentProjectid = this.localStorageService.getItem("currentProject");
        this.apiInputs.userprojectid = this.currentProjectid.__zone_symbol__value;
        this.uniqueProjectid = this.localStorageService.getItem("uniqueProjectid");
        this.apiInputs.useruniqueprojectid = this.uniqueProjectid.__zone_symbol__value;
        this.browserName = this.detectBrowserName();
        var ismobile = this.isMobile();
        var isMobileTablet = this.isMobileTablet();
        if (ismobile == true) {
            this.apiInputs.device_type = "mobile";
        } else if (isMobileTablet == true) {
            this.apiInputs.device_type = "tablet";
        } else {
            this.apiInputs.device_type = "desktop";
        }
        this.apiInputs.operating_system = this.operatingSystem;
        this.localStorageService.setItem("currentCustomer", this.token);
        this.showLoader();
        this.apiInputs.browser_name = this.browserName;
        this.apiInputs.useragent = navigator.userAgent;
        try {
            const rawResult: any = await this.apiService.postApi(this.apiInputs, 'user/getProjectData').toPromise(); // Convert Observable to Promise

            this.hideLoader();
            var result = JSON.parse(this.apiService.decode(rawResult.successdata));
            if (result.is_researchdefender == 1 && result.url_type == 1) {
                this.showLoader();
                const defenderResp: any = await this.checkresearchdefender(result);
                if (defenderResp.rdstatus == 100) {
                    this.message = defenderResp.message;
                    decodeURI(defenderResp.url);
                    window.location = defenderResp.url;
                }
            }

            if (result.is_verisoul == 1 && result.url_type == 1) {
                this.showLoader();
                const verisoulResp: any = await this.handleProjectData(result);
                this.hideLoader();

            }

            this.url_type = result.url_type;
            this.projectcode = result.project_code;
            this.resid = result.respondent_id;
            this.projectconntry = result.project_country;
            this.supcode = result.suppliercode;
            if (result.device_type) {
                this.device_type_resp = result.device_type;
            }
            this.is_boat = result.is_boat;
            this.status = result.status;
            this.is_email = result.is_email;

            this.captcha = result.is_captcha;
            this.textanalyzer = result.is_text_analyzer;
            if (result.message) {
                this.message = result.message;
                this.premsg = 1
            } else {
                this.message = '';
                this.premsg = 0
            }
            if (result.is_email == 1 && result.is_boat == 0) {
                this.is_email_message = result.is_email_message;
            }
            this.isquestion = result.question;
            this.url = result.url;


            if (result.is_boat == 0 && result.is_email == 0 && result.is_captcha == 1) {
                this.routeCustomrAuth();
            }
            if (result.is_boat == 0 && result.is_email == 0 && result.is_captcha == 0) {
                this.routeCustomrAuth();
            }

            if (result.status == 100) {
                this.routeCustomrAuth();
            }


        } catch (err) {
            this.hideLoader();
            this.router.navigate(['not-found']);
        }

    }

    showLoader() {
        $("#loader_form").show();
    }

    hideLoader() {
        $("#loader_form").hide();
    }

    routeCustomrAuth() {
        
        if (this.status == 1 && this.captcha == 0 && this.message == '' && this.textanalyzer == 0) {
            this.message = this.message;
            this.isquestion = this.isquestion;
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''

            ) {
                let encoded_qstn_title = '';
                if (this.get_question_arr) {
                    encoded_qstn_title = this.apiService.encode(JSON.stringify(this.get_question_arr));
                }
                this.router.navigate(
                    ['survey/survey'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'no', get_question_arr: encoded_qstn_title } }
                );
            }
        } else if (this.status == 1 && this.captcha == 0 && this.message == '' && this.textanalyzer == 1) {
            this.message = this.message;
            this.isquestion = this.isquestion;
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''

            ) {
                this.router.navigate(
                    ['survey/textanalyzer'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'no' } }
                );
            }
        } else if (this.status == 1 && this.message != '') {
            this.message = this.message;
        } else if (this.status == 1 && this.captcha == 1) {
            this.message = this.message;
            this.isquestion = this.isquestion;
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''

            ) {
                this.router.navigate(
                    ['survey/captcha'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'yes' } }
                );
            }

        } else if (this.status == 1 && this.textanalyzer == 1) {
            this.message = this.message;
            this.isquestion = this.isquestion;
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''

            ) {
                this.router.navigate(
                    ['survey/textanalyzer'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'yes' } }
                );
            }

        } else if (this.status == 0) {
            this.message = this.message;

        } else if (this.status == 11) {
            decodeURI(this.url);
            this.embeded_url = this.sanitized.bypassSecurityTrustResourceUrl(this.url);

        } else if (this.status == 2) {
            this.message = this.message;

        } else if (this.status == 12 && this.captcha == 1 && this.textanalyzer == 0) {
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''
            ) {
                this.router.navigate(
                    ['survey/captcha'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'yes' } }
                );
            }
        } else if (this.status == 12 && this.captcha == 1 && this.textanalyzer == 1) {
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''
            ) {
                this.router.navigate(
                    ['survey/captcha'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'yes' } }
                );
            }
        } else if (this.status == 12 && this.captcha == 0 && this.textanalyzer == 1) {
            if (
                typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''
            ) {
                this.router.navigate(
                    ['survey/textanalyzer'],
                    { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'yes' } }
                );
            }
        } else {

            var url = decodeURI(this.url);
            if (this.status == 100) {
                setTimeout(() => {
                    window.location = this.url;
                }, 2000)
            } else {
                this.apiService.postApi(this.apiInputs, 'user/get_client_url').subscribe((result) => {
                    var result = JSON.parse(this.apiService.decode(result.successdata));
                    var url = decodeURI(result.url);
                    window.location = result.url;
                }, (err) => {
                    this.hideLoader();
                    this.router.navigate(['not-found']);

                });
                //     window.location = this.url;
            }
        }


    }



    detectBrowserName() {
        const agent = window.navigator.userAgent.toLowerCase()
        switch (true) {
            case agent.indexOf('edge') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!(<any>window).opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'other';
        }
    }

    detectBrowserVersion() {
        var userAgent = navigator.userAgent, tem,
            matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        if (/trident/i.test(matchTest[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (matchTest[1] === 'Chrome') {
            tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
        return matchTest.join(' ');
    }

    isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                check = true;
        })(navigator.userAgent || navigator.vendor);
        return check;
    };

    isMobileTablet() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                check = true;
        })(navigator.userAgent || navigator.vendor);
        return check;
    }

    async getCustomerProject() {
        var currentProjectTemp: any = await this.localStorageService.getItem("currentProject");
        this.currentProjectid = JSON.parse(currentProjectTemp);
        // console.log('this.currentProjectid', this.currentProjectid);

    }

    verifyemail() {

        if (this.is_boat == 1) {
            if (this.captchaResponse == '') {
                this.apiService.showToast("Please select recaptcha value.", 2000);
                return false;
            }
        }

        var ansdata = this.email;

        var len = ansdata.toString().length;
        var eml = ansdata.includes("@");
        var eml2 = ansdata.includes(".");

        if (eml == '' || eml2 == '') {
            this.apiService.showToast("Please enter valid email.", 2000);
            return false;
        }
        // this.emaildata.email = this.email;
        this.apiInputs.email = this.email;
        // console.log('this.emaildata.email', this.emaildata.email);
        this.showLoader();
        this.apiService.postApi(this.apiInputs, 'user/verify_email').subscribe((result) => {
            var result = JSON.parse(this.apiService.decode(result.successdata));
            this.hideLoader();
            if (result.status == 1) {
                this.otp_send = result.otp_sent
                this.message = "Enter OTP"
                this.otp_message = result.otp_message
                this.resend = false;
                this.resendotp = true;
                this.update_sec = 60;
                this.apiService.showToast(result.message, 2000);
                return false;
            }



        }, (err) => {

            this.hideLoader();
            this.router.navigate(['not-found']);
            //console.log("Client/feedback_list", JSON.stringify(err));
        });

    }

    numberOnly(event) {
        if (event.toString().indexOf(".") != -1 || event.toString().indexOf("-") != -1 || event.toString().indexOf(",") != -1) {
            this.apiService.showToast('Enter valid otp', 2000);

            return false;
        } else {
            this.otp = event;
        }
    }


    verifyotp() {
        if (this.otp.length == 6) {
            this.showLoader();
            this.apiInputs.otp = this.otp;
            this.apiService.postApi(this.apiInputs, 'user/verify_otp').subscribe((result) => {
                var result = JSON.parse(this.apiService.decode(result.successdata));
                this.hideLoader();

                if (result.status == 1) {
                    if (result.pre_screen == 1) {
                        this.status = 1;
                        this.message = '';
                    } else {
                        this.status = 12;
                    }

                    this.otp_send = 0;
                    this.routeCustomrAuth();
                } else {
                    this.apiService.showToast(result.message, 2000);

                    return false;
                }



            }, (err) => {

                this.hideLoader();

            });
        } else {
            this.apiService.showToast('Enter valid otp', 2000);

            return false;
        }
    }

    submitcaptcha() {
        if (this.is_boat == 1) {
            if (this.captchaResponse == '') {
                this.apiService.showToast("Please select recaptcha value.", 2000);
                return false;
            }
        }
        this.is_boat = 0;
        this.premsg = 0;
        this.message = "";
    }

    submitmessage() {
        this.message = '';
        this.premsg = 0;
        this.routeCustomrAuth();
    }

    submitprescanmessage() {
        this.message = '';
        this.premsg = 0;

    }

    invokeAPI() {
        this.showLoader();
        var req = this.resid;
        var chanel = this.supcode;
        var event = this.projectcode;
        var country = this.projectconntry;
        var uniquenessParam = Forensic.createUniquenessParam(event);
        var geoParam = Forensic.createGeoParam(country);
        Forensic.forensic(req, this.successCallback.bind(this), this.errorCallback, uniquenessParam, geoParam, null, null, chanel);
        this.hideLoader();
    }

    successCallback = (jsonData) => {
        this.showLoader();
        this.apiInputs.jsondata = jsonData;
        this.apiService.postApi(this.apiInputs, 'user/updateAPIResponse').subscribe((result) => {
            var result = JSON.parse(this.apiService.decode(result.successdata));
            this.hideLoader();
            if (result.status == 0) {
                this.is_boat = 0;
                this.is_email = 0;
                this.message = result.message;
                decodeURI(result.url);
                window.location = result.url;
            }
        });
    };

    errorCallback(jsonData) {
        console.log(jsonData.error.message); // Add your logic to handle errors
    }

    async handleProjectData(result: any): Promise<boolean> {
        await (window as any).Verisoul.account({
            id: result.respondent_id,
            group: result.project_code
        });

        this.apiInputs.session_id = await (window as any).Verisoul.session();
        this.apiInputs.respondentId = result.respondent_id;
        this.apiInputs.projectCode = result.project_code;

        try {
           const resultdata: any = await this.apiService.postApi(this.apiInputs, 'user/update_verisoul_data').toPromise();

            const parsed = JSON.parse(this.apiService.decode(resultdata.successdata));

            if (resultdata.status === 1) {
                this.hideLoader();
                return true;
            } else {
                this.hideLoader();
                console.log('resultdata', parsed);
                this.message = parsed.message;
                decodeURI(parsed.url);
                 window.location = parsed.url;
                return false;
            }
        } catch (error) {
            this.hideLoader();
            console.error('API error:', error);
            return false;
        }
    }

    async checkresearchdefender(result: any): Promise<boolean | any> {
        try {

            const url = '';
            const response = await this.apiService.getData(url).toPromise();
            this.apiInputs.response = response;
            this.apiInputs.useruniqueprojectid = this.uniqueProjectid.__zone_symbol__value;
            this.apiInputs.projectcode = result.project_code;
            this.apiInputs.projectcountry = result.project_country;
            this.apiInputs.resid = result.respondent_id;
            const updateResponse: any = await this.apiService.postApi(this.apiInputs, 'user/updateDefenderResponse').toPromise();
            const parsed = JSON.parse(this.apiService.decode(updateResponse.successdata));
            if (parsed.rdstatus === 1) {
                this.hideLoader();
                return true;
            } else {
                this.hideLoader();
                return parsed;

            }
        } catch (err) {

            this.message = "Quality Terminate";
            const url = "https://crm.marketxcel.co.in/cron/testComplete?uid=[identifier]";
            decodeURI(url);
            //window.location.href = url;
        }
    }



}
